module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "ebook-toc",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Other books by Jeremy Greenberg")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "bold CharOverride-2"
  }, [_vm._v("Sorry I Humped Your Leg")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "bold CharOverride-2"
  }, [_vm._v("Sorry I Slept on Your Face")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "bold CharOverride-2"
  }, [_vm._v("Sorry I Peed on You")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "bold CharOverride-2"
  }, [_vm._v("Sorry I Pooped in Your Shoe")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "bold CharOverride-2"
  }, [_vm._v("Sorry I Barfed on Your Bed")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "bold CharOverride-2"
  }, [_vm._v("Kitty Hearts Doggy")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "bold CharOverride-2"
  }, [_vm._v("Stink Outside the Box")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/title.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('div', {
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/p5.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "ebook-toc",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "DEAR----"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Dear Hamstrung Human,")])]), _vm._v(" "), _c('p', {
    staticClass: "TEXT"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Not once have Charlie and I seen you attempt to jump from the kitchen table to the top of the china hutch, and we’re concerned. We think the problem is that your hamstrings are too tight. Please join us for yoga on the cat-hair-covered expensive yoga mat, on which we also practice our cleanse-pukes during off days. Every morning, you can deepen your practice as we bend over and lick toes. Not only will you feel a nice stretch in your back and tail but you’ll also be able to clean stuck bits of litter from between your toes. ")])]), _vm._v(" "), _c('p', {
    staticClass: "TEXT"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("After a few weeks, you’ll be leaping onto any surface that you’re not allowed without the fear of missing, falling into the fish tank, and being shamed in a viral video. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Signed-by---"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Namaste,")])]), _vm._v(" "), _c('p', {
    staticClass: "SIG2"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Robin")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "alt": "",
      "src": "image/2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('p', {
    staticClass: "RE--Name ParaOverride-3"
  }, [_c('span', {
    staticClass: "bold CharOverride-7"
  }, [_vm._v("Name:")]), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v(" Charlie (in upward sitting snowball) and Robin (in sideways stretching tabby)")])]), _vm._v(" "), _c('p', {
    staticClass: "RE--Name"
  }, [_c('span', {
    staticClass: "bold CharOverride-7"
  }, [_vm._v("Re:")]), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v(" Join us for yoga!")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('p', {
    staticClass: "DEAR----"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Dear Pants-crapping Human,")])]), _vm._v(" "), _c('p', {
    staticClass: "TEXT"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It obviously pains me deeply to know that you can’t find your cat. I understand he is white with a mostly black head and black tuft of fur under his chin and answers to the name of Meoni. I haven’t seen him. He’s definitely not sleeping on the bench in the backyard and choosing not to answer because he knows the can of food you’re tapping on is the same boring crap he’s eaten for ten years. He was last seen an hour ago, right before you left the sliding glass door open. There’s a reward for finding him, and that reward is listening to him loudly howl at you while you remove him from his place in the sun and carry him back into your dark house. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Signed-by---"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Sure hope you find him, ")])]), _vm._v(" "), _c('p', {
    staticClass: "SIG2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }), _c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("Meoni")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer011"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "alt": "",
      "src": "image/3.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('p', {
    staticClass: "RE--Name"
  }, [_c('span', {
    staticClass: "bold CharOverride-9"
  }, [_vm._v("Name:")]), _c('span', {
    staticClass: "CharOverride-10"
  }), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Meoni")])]), _vm._v(" "), _c('p', {
    staticClass: "RE--Name"
  }, [_c('span', {
    staticClass: "bold CharOverride-9"
  }, [_vm._v("Re:")]), _c('span', {
    staticClass: "CharOverride-10"
  }), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("This is how much I care ")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('p', {
    staticClass: "DEAR----"
  }, [_c('span', {
    staticClass: "CharOverride-13"
  }, [_vm._v("Dear Human Knucklehead,")])]), _vm._v(" "), _c('p', {
    staticClass: "TEXT"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Let me tellz ya about the time I seen this mouse coming for my food, see? This was back in my alley days, before youz nice people found me, cut my things off, and gave me this here bed soze the kids who live here can see the face of a champion. Anyway, I seez this mouse right at the time this other cat does. I sez, “Meow!” Then that bum cat sez, “Meow!” The mouse hears us both and runs away. I sez to the bum, I sez, “That’s my mouse.” The other cat sez, “What mouse?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "TEXT"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("“Oh, a wise guy–cat, huh?” I givez him a swat and another swat. And if I hadn’t already had a belly full of trash scraps, I’d have murdered the bum. Instead, we just hissed at each other once more and then decided to groom each other. I’m now godcat to her litter. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Signed-by---"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("See youz later!")])]), _vm._v(" "), _c('p', {
    staticClass: "SIG2"
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("Finnegan")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "alt": "",
      "src": "image/4.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer018"
    }
  }, [_c('p', {
    staticClass: "RE--Name"
  }, [_c('span', {
    staticClass: "bold CharOverride-15"
  }, [_vm._v("Name:")]), _c('span', {
    staticClass: "CharOverride-10"
  }), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Finnegan")])]), _vm._v(" "), _c('p', {
    staticClass: "RE--Name"
  }, [_c('span', {
    staticClass: "bold CharOverride-15"
  }, [_vm._v("Re:")]), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v(" Let me tellz youz about my fighting days")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer022"
    }
  }, [_c('p', {
    staticClass: "DEAR----"
  }, [_c('span', {
    staticClass: "CharOverride-17"
  }, [_vm._v("Dearest Grieving Human,")])]), _vm._v(" "), _c('p', {
    staticClass: "TEXT"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I saw you wiping down the cat carrier with that cloth that is supposed to make me like being in it, but unfortunately we can’t go to the vet at the moment because I’ve unexpectedly died. Yes, it’s very sad. But not that sad, considering I’ve got nine lives and spending one on getting out of going to the vet is a worthy sacrifice. Please call the vet and tell her the bad news. Let her know the cause of death is hating the kitten-print scrubs her assistants wear. I’m sure she’ll understand. And don’t try to call my name, because all I see is a bright light and kitty angels telling me going to the vet sucks and I should lie here unresponsive until you just scoop me up and make me go anyway.")])]), _vm._v(" "), _c('p', {
    staticClass: "Signed-by---"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Adorably departed,")])]), _vm._v(" "), _c('p', {
    staticClass: "SIG2"
  }, [_c('span', {
    staticClass: "CharOverride-18"
  }, [_vm._v("Ovid")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer019"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "alt": "",
      "src": "image/5.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer020"
    }
  }, [_c('p', {
    staticClass: "RE--Name"
  }, [_c('span', {
    staticClass: "bold CharOverride-16"
  }, [_vm._v("Name:")]), _c('span', {
    staticClass: "CharOverride-10"
  }), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Ovid ")])]), _vm._v(" "), _c('p', {
    staticClass: "RE--Name"
  }, [_c('span', {
    staticClass: "bold CharOverride-16"
  }, [_vm._v("Re:")]), _c('span', {
    staticClass: "CharOverride-10"
  }), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("I’d love to go the vet, but unfortunately I’m dead right now")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer023"
    }
  }, [_c('p', {
    staticClass: "DEAR----"
  }, [_c('span', {
    staticClass: "CharOverride-19"
  }, [_vm._v("Dear Underprotective Mommy,")])]), _vm._v(" "), _c('p', {
    staticClass: "TEXT"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Look, I wasn’t planning on drooling, and especially not on my new brother, but he drooled on me first. Tell Holden not to drool on me and I won’t drool on him. As my new brother, I have to make sure he understands that while I love him more than anything in the world, there’s nothing he can do that I can’t. Sure, I pooped on the carpet yesterday. But guess where I got the idea! That’s right, Holden showed me that not only will you not get angry at him for dropping a deuce on the ivory shag but you’ll blame the man-human for poorly strapping the white crap sack around Holden’s waist. And it would’ve never occurred to me to barf on you while you were holding me, but after you laughed as Holden spewed intestine-curdled milk onto your blouse, I figured I might as well add a little backyard-grass puke to the outfit. ")])]), _vm._v(" "), _c('p', {
    staticClass: "TEXT"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I’m just saying a bit of drool isn’t really that bad in comparison.")])]), _vm._v(" "), _c('p', {
    staticClass: "Signed-by---"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Love,")])]), _vm._v(" "), _c('p', {
    staticClass: "SIG2"
  }, [_c('span', {
    staticClass: "CharOverride-20"
  }, [_vm._v("Big Sis Tess")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer025"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "alt": "",
      "src": "image/6.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('p', {
    staticClass: "RE--Name"
  }, [_c('span', {
    staticClass: "bold CharOverride-21"
  }, [_vm._v("Name:")]), _c('span', {
    staticClass: "CharOverride-10"
  }), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Holden the Human and Tess the Cat")])]), _vm._v(" "), _c('p', {
    staticClass: "RE--Name"
  }, [_c('span', {
    staticClass: "bold CharOverride-21"
  }, [_vm._v("Re:")]), _c('span', {
    staticClass: "CharOverride-10"
  }), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Romeo and Drooliet")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer030"
    }
  }, [_c('p', {
    staticClass: "DEAR----"
  }, [_c('span', {
    staticClass: "CharOverride-22"
  }, [_vm._v("Dear Night-blind Biped,")])]), _vm._v(" "), _c('p', {
    staticClass: "TEXT"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("When I got you as a human, I thought there was an implicit agreement that those huge hands were for opening doors, windows, cans of food, and petting me at the times I can tolerate your apelike appearance and odor. Instead, you think those thumbs are for pretending to be some feline optometrist. I don’t need glasses to see that it’s after 2 p.m. and you still haven’t made your bed. Exactly what part of my vision were you hoping to fix? All these glasses do is magnify how poorly you use your free time. You do know that while my eyes may not be able to see colors the way yours do, my superior night vision clearly notices every gigantic spider that crawls across your head while you sleep. I’d help catch them, but I’m sure you can see why I won’t give you a hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "Signed-by---"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Enjoy your rash,")])]), _vm._v(" "), _c('p', {
    staticClass: "SIG2"
  }, [_c('span', {
    staticClass: "CharOverride-23"
  }, [_vm._v("Leila")]), _c('span', {
    staticClass: "CharOverride-5"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer027"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "alt": "",
      "src": "image/7.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer031"
    }
  }, [_c('p', {
    staticClass: "RE--Name"
  }, [_c('span', {
    staticClass: "bold CharOverride-24"
  }, [_vm._v("Name:")]), _c('span', {
    staticClass: "CharOverride-10"
  }), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Leila ")])]), _vm._v(" "), _c('p', {
    staticClass: "RE--Name"
  }, [_c('span', {
    staticClass: "bold CharOverride-24"
  }, [_vm._v("Re:")]), _c('span', {
    staticClass: "CharOverride-10"
  }), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Now you also look dumb from a distance")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer032"
    }
  }, [_c('p', {
    staticClass: "DEAR----"
  }, [_c('span', {
    staticClass: "CharOverride-22"
  }, [_vm._v("Dear Judges,")])]), _vm._v(" "), _c('p', {
    staticClass: "TEXT"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I know that if I practice day and night, I can become a superstar singing kitty and one day be the lead howler of Meowtallica. From my first memories as a tail-chaser, I’ve known the power of my voice to arouse emotion. Usually it’s the anger and annoyance of people trying to sleep, but it still helps humans connect with their feelings and throw pillows at me from across the room. I don’t want kitty stardom for my furry face alone. My poor human works so hard, and she’s gone all day. Once I become a big cat rock star, she can stay home and admire my incessant howling as she shoos groupie cats from off of the backyard fence. ")])]), _vm._v(" "), _c('p', {
    staticClass: "TEXT"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("If singing doesn’t work, I’m also a very evocative dancer—my favorite number being a samba across my human’s head as she sleeps.")])]), _vm._v(" "), _c('p', {
    staticClass: "Signed-by---"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It’s a gift,")])]), _vm._v(" "), _c('p', {
    staticClass: "SIG2"
  }, [_c('span', {
    staticClass: "CharOverride-23"
  }, [_vm._v("Luna")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer033"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "alt": "",
      "src": "image/8.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer035"
    }
  }, [_c('p', {
    staticClass: "RE--Name"
  }, [_c('span', {
    staticClass: "bold CharOverride-24"
  }, [_vm._v("Name:")]), _c('span', {
    staticClass: "CharOverride-10"
  }), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Luna")])]), _vm._v(" "), _c('p', {
    staticClass: "RE--Name"
  }, [_c('span', {
    staticClass: "bold CharOverride-24"
  }, [_vm._v("Re:")]), _c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v(" “")]), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("American Shorthair Idol”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b15f604","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SorryBarfedAgain_epub.vue
// module id = 60
// module chunks = 0